import { Popup, Loadmore, Indicator, Toast } from 'mint-ui'
import loadingComponent from './loading.vue'

let $vm

const loadingPlugin = {
	install (vue, pluginOptions = {
	}) {
		const Loading = vue.extend(loadingComponent)

		if (!$vm) {
			$vm = new Loading({
				el: document.createElement('div')
			})
			document.body.appendChild($vm.$el)
		}

		const loading = {
			show (options) {
				let text = ''
				if (!options && typeof options !== 'string') {
					// $vm.show = false
					Indicator.close()
					return
				}
				if (typeof options === 'string') {
					Object.assign($vm, pluginOptions, {
						text: options
					})
					text = options
				} else if (typeof options === 'object') {
					Object.assign($vm, pluginOptions, options)
					text = options.textt
				}
				// $vm.show = true
				Indicator.open(text)
				return $vm
			}
		}
		vue.prototype.$loading = loading.show
	}
}

export default loadingPlugin



// WEBPACK FOOTER //
// ./src/components/common/loading/index.js